import type { FindPanel } from '@/ui/findPanel';
import * as docSvc from '@/files/docService';

// ═══════════════════════════════════════════════════════════════
// Klávesové zkratky vázané na vlastní UI (sekce 2.1a).
//
// Formátovací zkratky (Ctrl+B/I/U), schránka, historie a výběr fungují
// nativně přes TipTap/contenteditable — ty ZDE neošetřujeme. Ošetřujeme jen
// zkratky vázané na vlastní UI a ukládání na disk:
//   Ctrl+S  → uložit (na disk, ne prohlížečové "uložit stránku")
//   Ctrl+F  → najít
//   Ctrl+H  → najít a nahradit
//   Ctrl+P  → tisk/PDF (Fáze 3 — zatím necháme nativní tisk)
//   Esc     → řeší si každý panel sám
// ═══════════════════════════════════════════════════════════════

export function registerShortcuts(findPanel: FindPanel): void {
  window.addEventListener('keydown', (e) => {
    const mod = e.ctrlKey || e.metaKey;
    if (!mod) return;
    const k = e.key.toLowerCase();

    if (k === 's') {
      e.preventDefault();
      void docSvc.save();
    } else if (k === 'f') {
      e.preventDefault();
      findPanel.show('find');
    } else if (k === 'h') {
      e.preventDefault();
      findPanel.show('replace');
    }
    // Ctrl+P ponecháme nativnímu tisku prohlížeče do doby, než bude Fáze 3
    // (Cloudflare Browser Rendering PDF export).
  });
}
